import routesData from './routes.json';
import Homepage from '@/pages/public/Homepage';
import WatchDemo from '@/pages/public/WatchDemo';
import Experience from '@/pages/public/Experience';
import ImproveLive from '@/pages/public/ImproveLive';
import WhyImprove from '@/pages/public/WhyImprove';
import CyberSecurity from '@/pages/public/CyberSecurity';
import Features from '@/pages/public/Features';
import CourseLibrary from '@/pages/public/CourseLibrary';
import Pricing from '@/pages/public/Pricing';
import BuyNow from '@/pages/public/BuyNow';
import GetStartedSuccess from '@/pages/public/GetStartedSuccess';
import GetStartedCancel from '@/pages/public/GetStartedCancel';
import Contact from '@/pages/public/Contact';
import Blog from '@/pages/public/Blog';
import About from '@/pages/public/About';
import SingleCourse from '@/pages/public/SingleCourse';
import PartnerProgramme from '@/pages/public/PartnerProgramme';
import PrivacyPolicy from '@/pages/public/PrivacyPolicy';
import eula from '@/pages/public/eula';
import UsagePolicy from '@/pages/public/UsagePolicy';
import BusinessCaseBlog from '@/pages/public/blogs/BusinessCaseBlog';
import MobilePhoneLearningBlog from '@/pages/public/blogs/MobilePhoneLearningBlog';
import LearningAndDevelopmentVitalSMEBusinessGrowth from '@/pages/public/blogs/LearningAndDevelopmentVitalSMEBusinessGrowth';
import SMEOutsourceLearningAndDevelopment from '@/pages/public/blogs/SMEOutsourceLearningAndDevelopment';
import OutsourcingCompanyAddPortfolio from '@/pages/public/blogs/OutsourcingCompanyAddPortfolio';
import BenefitsForSME from '@/pages/public/blogs/BenefitsForSME';
import SMECompaniesSucceedThroughOutsourcing from '@/pages/public/blogs/SMECompaniesSucceedThroughOutsourcing';
import Thankyou from '@/pages/public/Thankyou';
import HRIntegration from '@/pages/public/HRIntegration';
import FAQ from '@/pages/public/FAQ';
import Solutions from '@/pages/public/Solutions';
import SolutionOnboarding from '@/pages/public/solutions/Onboarding';
import SolutionCompliance from '@/pages/public/solutions/Compliance';
import SolutionDevelopment from '@/pages/public/solutions/Development';
import SolutionManagement from '@/pages/public/solutions/Management';
import SolutionHealthSafety from '@/pages/public/solutions/HealthSafety';
import SolutionPartnerTraining from '@/pages/public/solutions/PartnerTraining';
import SolutionInternalComms from '@/pages/public/solutions/InternalComms';
import LeadershipPlus from '@/pages/public/LeadershipPlus';
import Compare from '@/pages/public/Compare';
import CompareBreathe from '@/pages/public/compare/Breathe';
import CompareBrightHR from '@/pages/public/compare/BrightHR';
import CompareIHASCO from '@/pages/public/compare/IHASCO';
import CompareCitation from '@/pages/public/compare/Citation';
import CustomerStories from '@/pages/public/CustomerStories';
import Resources from '@/pages/public/Resources';
import Guides from '@/pages/public/resources/Guides';
import Webinars from '@/pages/public/resources/Webinars';
import Downloads from '@/pages/public/resources/Downloads';
import WhySwitch from '@/pages/public/WhySwitch';
import LaunchProgramme from '@/pages/public/LaunchProgramme';
import SecurityGdpr from '@/pages/public/SecurityGdpr';

const components = {
  Homepage,
  WatchDemo,
  Experience,
  ImproveLive,
  GetStarted: BuyNow,
  GetStartedSuccess,
  GetStartedCancel,
  BuyNow,
  WhyImprove,
  CyberSecurity,
  Features,
  HowImproveHelps: Features,
  CourseLibrary,
  Pricing,
  Contact,
  Blog,
  About,
  SingleCourse,
  PartnerProgramme,
  PrivacyPolicy,
  eula,
  UsagePolicy,
  BusinessCaseBlog,
  MobilePhoneLearningBlog,
  LearningAndDevelopmentVitalSMEBusinessGrowth,
  SMEOutsourceLearningAndDevelopment,
  OutsourcingCompanyAddPortfolio,
  BenefitsForSME,
  SMECompaniesSucceedThroughOutsourcing,
  Thankyou,
  HRIntegration,
  FAQ,
  Solutions,
  SolutionOnboarding,
  SolutionCompliance,
  SolutionDevelopment,
  SolutionManagement,
  SolutionHealthSafety,
  SolutionPartnerTraining,
  SolutionInternalComms,
  LeadershipPlus,
  Compare,
  CompareBreathe,
  CompareBrightHR,
  CompareIHASCO,
  CompareCitation,
  CustomerStories,
  Resources,
  Guides,
  Webinars,
  Downloads,
  WhySwitch,
  LaunchProgramme,
  SecurityGdpr,
};

const routes = routesData.map((route) => ({
  ...route,
  component: components[route.name.replace(/\s/g, '')],
}));

export default routes.map((route) => {
  const meta = {
    public: true,
    onlyLoggedOut: true,
  };
  return { ...route, meta };
});
